export function getProjectList() {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const allocateProjectList = userInfo.allocateProjectList || [];
  const list = allocateProjectList.map(item => ({label: item.desc, value: item.code}));
  return list;
}
export function checkProjectList() {
  const list = getProjectList();
  const codes = list.map(item => item.value);

  if (!codes.includes('3300')) {
    list.unshift({label: '网上农博', value: '3300'});
  }
  
  return list;
}


export function onlyValue() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16);
}

export function merge(target, obj, isclone = true) {
  const tg = isclone ? clone(target) : target;

  for (let key in obj) {
    if (!obj[key]) tg[key] = obj[key];
    else if (obj[key].constructor === Object) tg[key] = merge(tg[key] || {}, obj[key], isclone);
    else tg[key] = obj[key];
  }
  return tg;
}

export async function downLoadXls(data, filename, suffix = '.xlsx') {
  // const blob = new Blob([data]);

  // let blob = data;
  let blob = new Blob([data]);
  if (typeof data === 'string' && data.indexOf('http') !== -1) {
    const response = await fetch(data);
    blob = await response.blob();
  }
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = filename + suffix;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  URL.revokeObjectURL(link.href);
  document.body.removeChild(link);
}

// 获取省市区
export function getChildRegion(id = 0) {
  return new Promise(async (resolve) => {
    const res = await this.$axios.get(this.$api.commonNew.getChildRegion, { params: { regionCode: id } });
    if (res.code === 0) {
      const children = res.data.map((item) => ({ value: item.regionCode, label: item.regionName }));
      resolve(children);
    }
  });
}

// 获取展馆
export function getSiteInfo() {
  const setItem = (arr) => {
    return arr.map((item) => {
      const obj = { value: item.siteId, label: item.siteName };
      if (item.children.length) obj.children = setItem(item.children);
      return obj;
    });
  };
  return new Promise(async (resolve) => {
    const res = await this.$axios.get(this.$api.siteArea.listTest, {
      params: {
        siteType: 1,
      },
    });
    if (res.code === 0) {
      this.options = setItem(res.data);
      resolve(this.options);
    }
  });
}

// 获取 商品品类/前台类目
export function getCategoryList(type = 1) {
  return new Promise(async (resolve) => {
    const urlKey = type === 1 ? 'frontendCategoryTree' : 'frontendCategoryTreeYx';
    const res = await this.$axios.get(this.$api.backplat[urlKey]);
    if (res.code === 0) {
      resolve(res.data || []);
    }
  });
}

export function sleep(fn, options = {}) {
  const throttleKey = options.throttleKey || 'sleepTimer';

  if (fn[throttleKey]) {
    if (!options.debounce) return;

    clearTimeout(fn[throttleKey]);
    delete fn[throttleKey];
  }

  const delay = options.delay !== undefined ? options.delay : 300;
  fn[throttleKey] = setTimeout(() => {
    delete fn[throttleKey];
    const args = options.args || [];
    fn(...args);
  }, delay);
}


export function inNum(str, options = {}) {
  str = str + '';

  if (str === '.') return '';

  const opt = {
    limit: 2,
    zero: true,
    negative: false,
    ...options
  };

  if (!opt.zero && str === '0') return '';
  if (opt.negative && str === '-.') return '-';

  const limit = opt.limit ? '\.' : '';
  const negative = opt.negative ? '\-' : '';
  const patt = new RegExp(`[^0-9${limit}${negative}]`, 'g');
  const res = str.replace(patt, '');
  const i = res.indexOf('.');
  const arr = res.split('.');
  if (arr.length > 2) return arr[0];
  else if (arr.length === 2) return res.substring(0, i + opt.limit + 1);
  else {
    if (res === '0') return res;
    else return res.replace(/^0+/, '');
  }
}

export function minus(arg1, arg2) {
  let r1, r2, m, n;
  try {r1 = arg1.toString().split(".")[1].length;} catch (e) {r1 = 0;}
  try {r2 = arg2.toString().split(".")[1].length;} catch (e) {r2 = 0;}
  m = Math.pow(10, Math.max(r1, r2));
  n = (r1 >= r2) ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
}

export function times(arg1, arg2) {
  let m = 0, s1 = arg1.toString(), s2 = arg2.toString();
  try {m += s1.split(".")[1].length;} catch (e) {}
  try {m += s2.split(".")[1].length;} catch (e) {}
  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
}